import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('lu_user')); } catch { return null; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('lu_token');
    if (!token) { setReady(true); return; }
    api.get('/auth/me').then((r) => {
      setUser(r.data);
      localStorage.setItem('lu_user', JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem('lu_token');
      localStorage.removeItem('lu_user');
      setUser(null);
    }).finally(() => setReady(true));
  }, []);

  const login = async (username, password) => {
    const r = await api.post('/auth/login', { username, password });
    localStorage.setItem('lu_token', r.data.token);
    localStorage.setItem('lu_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('lu_token');
    localStorage.removeItem('lu_user');
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, ready, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
